import MultiForm from '@admin/components/multiform'
import PropTypes from 'prop-types'
import Choose from './choose'
import Details from './details'
import Type from './type'
import React from 'react'
import { str } from 'ajv'

class New extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    form: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <MultiForm { ...this._getMultiForm() } />
  }

  _getMultiForm() {
    const { form } = this.props
    return {
      title: 't(New Landing Page)',
      action: `/api/admin/forms/forms/${form.id}/landing_pages`,
      method: 'POST',
      formatData: this._getData.bind(this),
      getSteps: this._getSteps.bind(this),
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess
    }
  }

  _getData(landing_page) {
    return {
      title: landing_page.title,
      theme_id: landing_page.theme_id,
      permalink: landing_page.permalink,
      strategy: landing_page.strategy,
      ...landing_page.truevail_template ? {
        truevail_template_id: landing_page.truevail_template.id,
        truevail_template_variant_id: landing_page.truevail_template.variants[0].id
      } : {}
    }
  }

  _getSteps(formdata) {
    return [
      { label: 't(Type)', component: Type },
      ...formdata.strategy !== 'scratch' ? [
        { label: 't(Choose)', component: Choose }
      ] : [],
      { label: 't(Details)', component: Details }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(landing_page) {
    const { form } = this.props
    this.context.router.push(`/admin/forms/forms/${form.id}/landing_pages/${landing_page.id}`)
    this.context.modal.close()
  }

}

export default New